const componentsContext = require.context('./', false, /\.vue$/)
const componentMap = componentsContext.keys().reduce((acc, filePath) => {
  const componentName = filePath.replace('./', '').replace('.vue', '')
  acc[componentName] = () => import(`./${componentName}.vue`)
  return acc
}, {})

export const resolveEventComponent = type => componentMap[type] || componentMap.EventUnknown

export function getAllEventComponentNames() {
  return Object.keys(componentMap)
}